<template>
  <div class="flex w-full flex-col items-center justify-start gap-5 lg:py-10">
    <div class="py-5">
      <img
        src="~/assets/images/logo_docue_black.svg"
        width="76"
      >
    </div>
    <div
      class="
          w-full
          max-w-xl
          border
          border-gray-200
          px-4
          py-6
          empty:hidden
          sm:w-[36rem]
          sm:rounded-xl
          md:p-8
          "
    >
      <header
        v-if="$slots.header"
        class="
            -mx-4
            -mt-6
            mb-6
            flex
            h-16
            items-center
            border-b
            px-4
            md:-mx-8
            md:-mt-8
            md:px-8
            "
      >
        <slot name="header" />
      </header>
      <slot />
    </div>
    <AppLocaleSelect class="h-auto w-min p-0 ring-offset-2" />
  </div>
</template>
